import React from "react";
import styled from "styled-components";

// context

// components
import { StyledText } from "./basic";

const Privacy = ({ currentTerm }) => {
  return (
    <MainHolder currentTerm={currentTerm}>
      <StyledText height={32} margin={30} fontFamily={600} align={"center"}>
        {currentTerm.header}
      </StyledText>
      {currentTerm.body.map((item) => {
        return (
          <>
            <StyledText height={18} size={14} color={"#e31c79"}>
              {item.title}
            </StyledText>
            <StyledText align={"justify"} height={18} size={12}>
              {item.details}
            </StyledText>
          </>
        );
      })}
    </MainHolder>
  );
};

const MainHolder = styled.div`
  display: grid;
  align-content: flex-start;
  border-radius: 30px;
  padding: ${({ currentTerm }) => (currentTerm ? `15px` : `5px`)};
  background-color: #f2f2f2;
  height: 645px;
  overflow: scroll;
  padding-bottom: 0px;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    height: 100vh;
  }
`;

export default Privacy;

Privacy.propTypes = {};
